import CryptoJS from 'crypto-js';
import isEmpty from 'lodash/isEmpty';

export const decrypt = (base64Data = null) => {

    if (!base64Data || isEmpty(base64Data)) 
        return null;

    let cleaned = base64Data.replace(/\s/g, '').replace(/-/g, '+').replace(/_/g, '/');
    while (cleaned.length % 4 !== 0) cleaned += '=';

    const raw = CryptoJS.enc.Base64.parse(cleaned);

    const iv = CryptoJS.lib.WordArray.create(raw.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(raw.words.slice(4), raw.sigBytes - 16);

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext },
        CryptoJS.enc.Utf8.parse(process.env.EXPO_PUBLIC_CRYPT_KEY),
        {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    const utf8 = decrypted.toString(CryptoJS.enc.Utf8);
    
    return utf8;
};